import memberService from "@/services/memberService.js";
import navigationService from './../../services/navigationService.js';
import defaultHeadImg from './../../assets/portrait_bg.png';
import appConsts from './../consts.js';

export default {
    namespaced: true,
    state() {
        return {
            member: {
                id: '',
                name: '',
                headImgUrl: defaultHeadImg,
                hasBindCustomer: false,
                hasElectronicMemberCard: false,
                permissions: [],
                menuItems: [],
                shouldLoad: true
            }
        }
    },
    mutations: {
        [appConsts.setMember](state, member) {
            state.member = member;
        },
        shouldLoad(state) {
            state.member.shouldLoad = true;
        },
        registMemberCard(state) {
            state.member.hasElectronicMemberCard = true;
        }
    },
    actions: {
        async [appConsts.loadMemberAsync](context) {
            if (context.state.member.shouldLoad) {
                let member = await memberService.getMemberInfoAsync();
                if(member){
                    if (!member.headImgUrl) {
                        member.headImgUrl = defaultHeadImg;
                    }
                    let menu = await navigationService.getMenuAsync();
                    member.menuItems = menu.items;
                    member.shouldLoad = false;
                    context.commit(appConsts.setMember, member);
                }                
            }
        },
        async [appConsts.refreshMemberAsync](context) {
            context.commit("shouldLoad");
            await context.dispatch(appConsts.loadMemberAsync);
        }
    }
}